import * as Yup from "yup";

export class FormValidationSchema {
  static requiredSchema(isRequired, showField, msg) {
    if (isRequired && showField) {
      return Yup.string().required(msg);
    }
    return Yup.string();
  }

  constructor(fields) {
    this.formValidationSchema = Yup.object().shape(this._getFormSchema(fields));
    // this.formValidationSchema = Yup.object().shape({
    //   standard_Fields: Yup.array().of(
    //     Yup.object().shape({
    //       textField: Yup.string().required("Name is required"),
    //     })
    //   ),
    // });
  }

  firstName(options) {
    if (options.isRequired) {
      return Yup.string()
        .min(3, "Must be 3 characters or more")
        .required("FirstName is Required");
    }
    return Yup.string().min(3, "Must be 3 characters or more");
  }

  lastName(options) {
    if (options.isRequired) {
      return Yup.string()
        .min(3, "Must be 3 characters or more")
        .required("LastName is Required");
    }
    return Yup.string().min(3, "Must be 3 characters or more");
  }

  email(options) {
    if (options.isRequired) {
      return Yup.string()
        .email("Invalid email format")
        .required("Email is Required");
    }
    return Yup.string().email("Invalid email format");
  }

  phone(options) {
    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    if (options.isRequired) {
      return Yup.string()
        .required("Phone number is Required")
        .matches(phoneRegExp, "Phone number is not valid");
    }
    return Yup.string().matches(phoneRegExp, "Phone number is not valid");
  }

  address(options) {
    const { addressLine1, addressLine2, city, state, zipCode, country } =
      options.fields;
    const schema = Yup.object().shape({
      addressLine1: FormValidationSchema.requiredSchema(
        addressLine1.isRequired,
        addressLine1.showField,
        "Required"
      ),
      addressLine2: FormValidationSchema.requiredSchema(
        addressLine2.isRequired,
        addressLine2.showField,
        "Required"
      ),
      city: FormValidationSchema.requiredSchema(
        city.isRequired,
        city.showField,
        "Required"
      ),
      state: FormValidationSchema.requiredSchema(
        state.isRequired,
        state.showField,
        "Required"
      ),
      zipCode: FormValidationSchema.requiredSchema(
        zipCode.isRequired,
        zipCode.showField,
        "Required"
      ),
      country: FormValidationSchema.requiredSchema(
        country.isRequired,
        country.showField,
        "Required"
      ),
    });
    return schema;
  }

  textField(options) {
    //console.log("options.isRequired", options.isRequired);
    // if (options.isRequired) {
    //   return Yup.array().required("textField is required");
    // }
    // return Yup.array();
  }

  url(options) {
    //const urlRegExp = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    // if (options.isRequired) {
    //   return Yup.array().required("url is required");
    // }
    // return Yup.array();
  }

  rating(options) {
    // if (options.isRequired) {
    //   return Yup.array().required("rating is required");
    // }
    // return Yup.array();
  }

  paragraph(options) {
    // if (options.isRequired) {
    //   return Yup.array().required("paragraph is required");
    // }
    // return Yup.array();
  }

  number(options) {
    // const numberRegEx = /^[0-9]/;
    // if (options.isRequired) {
    //   return Yup.array().required("number is required");
    // }
    // return Yup.array();
  }

  dropDown(options) {
    // if (options.isRequired) {
    //   return Yup.array().required("dropdown is required");
    // }
    // return Yup.array();
  }

  checkBox(options) {
    // if (options.isRequired) {
    //   return Yup.array().required("checkBox is required");
    // }
    // return Yup.array();
  }
  _getFormSchema(fields) {
    const formSchema = {};
    fields.forEach((field) => {
      const fieldSchema = this[field.type](field);
      formSchema[field.type] = fieldSchema;
    });
    return formSchema;
  }
}
